/**
 * @generated SignedSource<<663ccbd8b5d0902092672721cbaf38f5>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import type { ConcreteRequest } from 'relay-runtime';
import type { FragmentRefs } from "relay-runtime";
export type ContentPlatformContentQueryInput = {
  after?: string | null | undefined;
  first?: number | null | undefined;
  sortBy?: ContentPlatformSortClause | null | undefined;
  where?: ContentPlatformContentClause | null | undefined;
  withFallback?: string | null | undefined;
  withLocales?: ReadonlyArray<string> | null | undefined;
  withProductFeatureFlags?: any | null | undefined;
};
export type ContentPlatformSortClause = {
  fieldNamed?: string;
  havingOrder?: string;
};
export type ContentPlatformContentClause = {
  and?: ReadonlyArray<ContentPlatformContentClause> | null | undefined;
  fieldNamed?: string | null | undefined;
  gte?: ContentPlatformDateCondition | null | undefined;
  hasAnyValue?: boolean | null | undefined;
  havingValues?: ReadonlyArray<string> | null | undefined;
  lte?: ContentPlatformDateCondition | null | undefined;
  or?: ReadonlyArray<ContentPlatformContentClause> | null | undefined;
  searchText?: ContentPlatformSearchTextClause | null | undefined;
};
export type ContentPlatformDateCondition = {
  dateFieldNamed?: string;
  havingDate: any;
};
export type ContentPlatformSearchTextClause = {
  and?: ReadonlyArray<ContentPlatformSearchTextClause> | null | undefined;
  exactlyMatching?: ContentPlatformSearchTextMatchingClause | null | undefined;
  or?: ReadonlyArray<ContentPlatformSearchTextClause> | null | undefined;
  partiallyMatching?: ContentPlatformSearchTextMatchingClause | null | undefined;
};
export type ContentPlatformSearchTextMatchingClause = {
  and?: ReadonlyArray<ContentPlatformSearchTextMatchingClause> | null | undefined;
  fieldNamed?: string | null | undefined;
  havingValues?: ReadonlyArray<string> | null | undefined;
  matchingAllValues?: boolean | null | undefined;
  or?: ReadonlyArray<ContentPlatformSearchTextMatchingClause> | null | undefined;
};
export type templatePaginatedSearchResultsRefetchableQuery$variables = {
  searchQuery: ContentPlatformContentQueryInput;
};
export type templatePaginatedSearchResultsRefetchableQuery$data = {
  readonly " $fragmentSpreads": FragmentRefs<"templatePaginatedSearchResultsRelayRefetchableFragment">;
};
export type templatePaginatedSearchResultsRefetchableQuery = {
  response: templatePaginatedSearchResultsRefetchableQuery$data;
  variables: templatePaginatedSearchResultsRefetchableQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "searchQuery"
  }
],
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v2 = [
  (v1/*: any*/)
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "templatePaginatedSearchResultsRefetchableQuery",
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "searchQuery",
            "variableName": "searchQuery"
          }
        ],
        "kind": "FragmentSpread",
        "name": "templatePaginatedSearchResultsRelayRefetchableFragment"
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "templatePaginatedSearchResultsRefetchableQuery",
    "selections": [
      {
        "alias": null,
        "args": [
          {
            "fields": [
              {
                "items": [
                  {
                    "kind": "Variable",
                    "name": "queries.0",
                    "variableName": "searchQuery"
                  }
                ],
                "kind": "ListValue",
                "name": "queries"
              }
            ],
            "kind": "ObjectValue",
            "name": "search"
          }
        ],
        "concreteType": "ContentPlatformTemplateContentSearchConnection",
        "kind": "LinkedField",
        "name": "templates",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ContentPlatformTemplateResultEdge",
            "kind": "LinkedField",
            "name": "edges",
            "plural": true,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ContentPlatformTemplate",
                "kind": "LinkedField",
                "name": "node",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "templateId",
                    "storageKey": null
                  },
                  (v1/*: any*/),
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "urlSlug",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "pluginModuleKey",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "kind": "ScalarField",
                    "name": "previewBlurb",
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ContentPlatformTaxonomyTemplateType",
                    "kind": "LinkedField",
                    "name": "templateType",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "id",
                        "storageKey": null
                      },
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "templateTypeName",
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  },
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": null,
                    "kind": "LinkedField",
                    "name": "contributor",
                    "plural": false,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "kind": "ScalarField",
                        "name": "__typename",
                        "storageKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": (v2/*: any*/),
                        "type": "ContentPlatformOrganization",
                        "abstractKey": null
                      },
                      {
                        "kind": "InlineFragment",
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ContentPlatformOrganization",
                            "kind": "LinkedField",
                            "name": "organization",
                            "plural": false,
                            "selections": (v2/*: any*/),
                            "storageKey": null
                          }
                        ],
                        "type": "ContentPlatformAuthor",
                        "abstractKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "concreteType": "PageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "hasNextPage",
                "storageKey": null
              },
              {
                "alias": null,
                "args": null,
                "kind": "ScalarField",
                "name": "endCursor",
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "72eac936275017e96add193749036c77",
    "id": null,
    "metadata": {},
    "name": "templatePaginatedSearchResultsRefetchableQuery",
    "operationKind": "query",
    "text": "query templatePaginatedSearchResultsRefetchableQuery(\n  $searchQuery: ContentPlatformContentQueryInput!\n) {\n  ...templatePaginatedSearchResultsRelayRefetchableFragment_2rw059\n}\n\nfragment templateCardRelayFragment on ContentPlatformTemplate {\n  templateId\n  name\n  urlSlug\n  pluginModuleKey\n  previewBlurb\n  templateType {\n    id\n    templateTypeName\n  }\n  contributor {\n    __typename\n    ... on ContentPlatformOrganization {\n      name\n    }\n    ... on ContentPlatformAuthor {\n      organization {\n        name\n      }\n    }\n  }\n}\n\nfragment templatePaginatedSearchResultsRelayRefetchableFragment_2rw059 on Query {\n  templates(search: {queries: [$searchQuery]}) {\n    edges {\n      node {\n        templateId\n        name\n        urlSlug\n        ...templateCardRelayFragment\n      }\n    }\n    pageInfo {\n      hasNextPage\n      endCursor\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "dac86ac8a8eb6ab17bdc9f6204cf08bc";

export default node;
